/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import SuccessMessage from './components/Message'
import AssetList from './components/AssetList'
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalFooter,
  Button
} from '@chakra-ui/react'
import { postLicensedAsset } from '@/services/licensed-assets'
import DefaultAlert from '@/components/alerts/DefaultAlert'
import { setErrorCodeAndMessage } from '@/utils/fetch'

const ModalAsset = ({
  clearSelectedAssets,
  assets,
  reloadItems,
  setIsProcessing,
  setModalIsVisible
}) => {
  const [processEnded, setProcessEnded] = useState(false)
  const [hasAlert, setHasAlert] = useState(false)
  const [alert, setAlert] = useState()

  const [asset, setAsset] = useState(false)
  const [success, setSuccess] = useState(false)
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const processedAssets = assets.map(asset => ({
    assetId: asset.id
  }))
  const createLicensedAssets = async () => {
    try {
      setHasAlert(false)
      setAlert(null)
      setIsProcessing(true)

      const assets = await postLicensedAsset(processedAssets, getAccessToken)

      setProcessEnded(true)
      setAsset(assets)
      setIsProcessing(false)
      setSuccess(true)

      return assets
    } catch (error) {
      setHasAlert(true)
      setAlert(setErrorCodeAndMessage(error))
      setIsProcessing(false)
    }
  }

  const closeModal = async () => {
    setModalIsVisible()
    clearSelectedAssets()

    success && await reloadItems()
  }

  return (
    <Modal
      isOpen={true}
      onClose={closeModal}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          License Asset
        </ModalHeader>
        <ModalCloseButton />
        { !processEnded
          ? <>
              <ModalBody>
                { hasAlert &&
                  <DefaultAlert
                    message={alert?.code}
                    status="error"
                  />
                }
                <p>Are you sure you want to license this asset for building AI Metadata? Total Cost: {assets[0].buildLicenseListingTerms.minimumPrice} USDż</p>
                <AssetList assets={assets} />
              </ModalBody>
              <ModalFooter>
                <Button
                  data-testid="modal-close-button"
                  variant="ghost"
                  className="mr-sm"
                  onClick={() => setModalIsVisible(false)}
                >
                  Cancel
                </Button>
                <Button
                  onClick={createLicensedAssets}
                >
                  License Asset
                </Button>
              </ModalFooter>
            </>
          : <ModalBody>
              <SuccessMessage
                asset={asset}
              />
            </ModalBody>
        }
      </ModalContent>
    </Modal>
  )
}

export default ModalAsset
